module.exports = __webpack_public_path__ + "static/media/arrowRight.1c63a87a.svg";